import React from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import classNames from "classnames";
import dashboard from "../../../images/sidebar_icon/dashboard.png";
import users from "../../../images/sidebar_icon/user.png";
import duplicate_check from "../../../images/sidebar_icon/duplicate-check.svg";
import clients from "../../../images/sidebar_icon/Clients.png";
import candidates from "../../../images/sidebar_icon/graduated.png";
import employee from "../../../images/sidebar_icon/EmployeeIcon.png";
import requirement from "../../../images/sidebar_icon/requirement.png";
import whatsapp from "../../../images/sidebar_icon/whatsapp.png";
import search from "../../../images/sidebar_icon/search.png";
import report from "../../../images/sidebar_icon/Report.png";
import setting from "../../../images/sidebar_icon/setting.png";
import price from "../../../images/sidebar_icon/pricing.png";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import AssignReq from "../../../images/sidebar_icon/AssignReq.png";
import profileIcons from "../../../images/employee/sidebar/profile.png";
import JDRepositories from "../../../images/sidebar_icon/jdRepositories.png";

import useStyles from "../styles";
import { jwtDecode } from "jwt-decode";
import SidebarLink from "../components/SidebarLink/SidebarLink";

const AdminSidebar = ({ location, isSidebarOpened }) => {
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const companyType = decode.companyType;
  const classes = useStyles();
  const adminSidebarItems = [
    {
      id: 0,
      label: "Live Status",
      link: "/app/dashboard",
      view: true,
      icon: (
        <Tooltip title="Live Status" placement="right">
          <IconButton>
            <img
              src={dashboard}
              alt="dashboard"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 138,
      label: "Employee Details",
      link: "/app/employees",
      view: true,
      icon: (
        <Tooltip title="Employee Details" placement="right">
          <IconButton>
            <img
              src={employee}
              alt="employee"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 1,
      label: "Other Users",
      link: "/app/users",
      view: true,
      icon: (
        <Tooltip title="Other Users" placement="right">
          <IconButton>
            <img
              src={candidates}
              alt="users"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 2,
      label: companyType === "COMPANY" ? "Projects" : "Clients",
      link: companyType === "COMPANY" ? "/app/projects" : "/app/clients",
      view: true,
      icon: (
        <Tooltip
          title={companyType === "COMPANY" ? "Projects" : "Clients"}
          placement="right"
        >
          <IconButton>
            <img
              src={clients}
              alt={companyType === "COMPANY" ? "Projects" : "Clients"}
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 3,
      label: "Requirements",
      link: "/app/requirements",
      view: true,
      icon: (
        <Tooltip title="Requirements" placement="right">
          <IconButton>
            <img
              src={requirement}
              alt="requirement"
              className={classNames(classes.Icon2)}
            />
          </IconButton>
        </Tooltip>
      ),
    },  
     {
      id: 33,
      label: "JD Repositories",
      link: "/app/jd-repositories",
      view: true,
      icon: (
        <Tooltip title="JD Repositories" placement="right">
          <IconButton>
            <img
              src={JDRepositories}
              alt="requirement"
              className={classNames(classes.Icon11)}
              width={10}
              height={10}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 4,
      label: "Assign Requirements Candidates",
      link: "/app/assign_requirements",
      view: true,
      icon: (
        <Tooltip title="Assigned Requirements" placement="right">
          <IconButton>
            <img
              src={AssignReq}
              alt="requirement"
              className={classNames(classes.Icon2)}
            />
          </IconButton>
        </Tooltip>
      ),
    },

    {
      id: 5,
      label: "Candidates",
      link: "/app/admin_candidates",
      view: true,
      icon: (
        <Tooltip title="Candidates" placement="right">
          <IconButton>
            <img
              src={users}
              alt="candidates"
              className={classNames(classes.Icon3)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 587,
      label: "Check Duplicates",
      link: "/app/check_duplicate_candidates",
      view: true,
      icon: (
        <Tooltip title="Check Duplicates" placement="right">
          <IconButton>
            <img
              src={duplicate_check}
              alt="candidates"
              className={classNames(classes.Icon3)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 6,
      label: "Search Candidates",
      link: "/app/search",
      view: true,
      icon: (
        <Tooltip title="Search Candidates" placement="right">
          <IconButton>
            <img
              src={search}
              alt="search candidates"
              className={classNames(classes.Icon4)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    // {
    //   id: 7,
    //   label: "Invoiced Candidates",
    //   link: "/app/invoice",
    //   view: true,
    //   icon: (
    //     <Tooltip title="Invoiced Candidates" placement="right">
    //       <IconButton>
    //         <img
    //           src={invoice}
    //           alt="invoice"
    //           className={classNames(classes.Icon1)}
    //         />
    //       </IconButton>
    //     </Tooltip>
    //   ),
    // },
    {
      id: 8,
      label: "Chat",
      link: "/app/chat",
      view: decode.isEnablePaid === true ? true : false,
      icon: (
        <Tooltip title="Chat" placement="right">
          <IconButton>
            <img
              src={whatsapp}
              alt="whatsapp"
              className={classNames(classes.Icon4)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 9,
      label: "Reports",
      type: "reports",
      link: "/app/reports",
      view: true,
      icon: (
        <Tooltip title="Reports" placement="right">
          <IconButton>
            <img
              src={report}
              alt="report"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
      subMenu: [
        {
          id: 0,
          label:
            companyType === "COMPANY"
              ? "Submitted to Hiring Manager"
              : "Submitted to Client",
          link: "/app/reports/all_candidates_stc",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 1,
          label: "Final Interview Completed",
          link: "/app/reports/all_candidates_fic",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 2,
          label: "Document Collected",
          link: "/app/reports/all_candidates_document_collected",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 3,
          label: "Salary Breakup Shared",
          link: "/app/reports/all_candidates_salary_breakup_shared",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 4,
          label: "Offered",
          link: "/app/reports/all_candidates_offered",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 5,
          label: "Offer Declined",
          link: "/app/reports/all_candidates_Offered_declined",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 6,
          label: "Joined",
          link: "/app/reports/all_candidates_joined",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 7,
          label: "Not Joined",
          link: "/app/reports/all_candidates_ditched",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 8,
          label:
            companyType === "COMPANY"
              ? "Freelancer On-boarded Candidates"
              : "Invoiced Candidates",
          link:
            companyType === "COMPANY"
              ? "/app/reports/freelancer_onboarded_candidates"
              : "/app/reports/all_candidates_invoiced",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 9,
          label: "Credit Note",
          link: "/app/reports/all_candidates_credit_note",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 10,
          label: "Dropped",
          link: "/app/reports/all_candidates_drop",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
      ],
    },
    {
      id: 10,
      label: "Sources",
      type: "settings",
      link: "/app/settings",
      view: true,
      icon: (
        <Tooltip title="Settings" placement="right">
          <IconButton>
            <img
              src={setting}
              alt="setting"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
      subMenu: [
        // {
        //     id: 1,
        //     label: "Freelancer Invoice",
        //     link: "/app/settings/admin_invoice_history",
        //     icon: (
        //         <IconButton>
        //             <ArrowLeftIcon />
        //         </IconButton>
        //     ),
        // },
        // {
        //     id: 2,
        //     label: "Vendor Invoice",
        //     link: "/app/settings/vendor_invoice_history",
        //     icon: (
        //         <IconButton>
        //             <ArrowLeftIcon />
        //         </IconButton>
        //     ),
        // },
        {
          id: 2,
          label: "Department & Designation",
          link: "/app/settings/department-designation",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 3,
          label: "Source of Profile",
          link: "/app/settings/source",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        },
        {
          id: 4,
          label: "Free Message Activity",
          link: "/app/settings/free_message_activity",
          icon: (
            <IconButton>
              <ArrowLeftIcon />
            </IconButton>
          ),
        }
      ],
    },
    {
      id: 120,
      label: "Employee",
      // type: "employee",
      link: "/app/employee/dashboard",
      view: true,
      icon: (
        <Tooltip title="Employee" placement="right">
          <IconButton>
            <img
              src={profileIcons}
              alt="employee"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
      // subMenu: [
      //   // {
      //   //   id: 1,
      //   //   label: "Employee Details",
      //   //   link: "/app/employee/employee",
      //   //   icon: (
      //   //     <IconButton>
      //   //       <ArrowLeftIcon />
      //   //     </IconButton>
      //   //   ),
      //   // },
      //   {
      //     id: 2,
      //     label: "Loss of Pay List",
      //     link: "/app/employee/lop-details",
      //     icon: (
      //       <IconButton>
      //         <ArrowLeftIcon />
      //       </IconButton>
      //     ),
      //   },
      //   // {
      //   //   id: 212390,
      //   //   label: "Generate Payslip",
      //   //   link: "/app/employee/generate-payslip",
      //   //   icon: (
      //   //     <IconButton>
      //   //       <ArrowLeftIcon />
      //   //     </IconButton>
      //   //   ),
      //   // },
      //   {
      //       id: 3,
      //       label: "Projects",
      //       link: "/app/employee/projects",
      //       icon: (
      //         <IconButton>
      //           <ArrowLeftIcon />
      //         </IconButton>
      //       ),
      //     },
      //   {
      //     id: 4,
      //     label: "Employee Opinions",
      //     link: "/app/employee/opinions/yet-to-reply",
      //     icon: (
      //       <IconButton>
      //         <ArrowLeftIcon />
      //       </IconButton>
      //     ),
      //   },
      //   {
      //     id: 5,
      //     label: "Leave Management",
      //     link: "/app/employee/leave/yet-to-approve",
      //     icon: (
      //       <IconButton>
      //         <ArrowLeftIcon />
      //       </IconButton>
      //     ),
      //   },
      //   {
      //     id: 7,
      //     label: "Permissions Management",
      //     link: "/app/employee/permission/yet-to-approve",
      //     icon: (
      //       <IconButton>
      //         <ArrowLeftIcon />
      //       </IconButton>
      //     ),
      //   },
      //   {
      //     id: 2190,
      //     label: "Internal Job Posting",
      //     link: "/app/employee/internal-jobpostings",
      //     icon: (
      //       <IconButton>
      //         <ArrowLeftIcon />
      //       </IconButton>
      //     ),
      //   },
      //   {
      //       id: 77,
      //       label: "List of Holidays",
      //       link: "/app/employee/leave-calendar",
      //       icon: (
      //         <IconButton>
      //           <ArrowLeftIcon />
      //         </IconButton>
      //       ),
      //     }, 
      //     {
      //       id: 92183,
      //       label: "Policy Handbook",
      //       link: "/app/employee/policy-handbook",
      //       icon: (
      //         <IconButton>
      //           <ArrowLeftIcon />
      //         </IconButton>
      //       ),
      //     },
      // ],
    },
    {
      id: 11,
      label: "Refo Billing",
      link: "/app/plans",
      view: true,
      icon: (
        <Tooltip title="Billing" placement="right">
          <IconButton>
            <img
              src={price}
              alt="price"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      {adminSidebarItems
        .filter(
          (link) =>
            (companyType !== "COMPANY" || link.label !== "Refo Billing") &&
            link.label !== "Assign Requirements Candidates",
        )
        .map((link) => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
    </>
  );
};

export default AdminSidebar;
